export function buildFileUrl(path, baseUrl = process.env.VUE_APP_WEB_BASE_URL || "") {
  if (!path || typeof path !== "string") {
    return "";
  }
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const cleanPath = path.replace(/^\/+/, "").replace(/\\/g, "/");

  // Agency docs uploaded to S3 (storage/agencies/{id}/...)
  const s3Base = String(process.env.VUE_APP_S3_URL || "").replace(/\/$/, "");
  if (cleanPath.startsWith("storage/agencies/") && s3Base) {
    return `${s3Base}/${cleanPath}`;
  }

  const normalizedBase = String(baseUrl).replace(/\/$/, "");
  return normalizedBase ? `${normalizedBase}/${cleanPath}` : `/${cleanPath}`;
}
